"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Star.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Star = function Star(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 234.42 208.71"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Star Icon"), _react2.default.createElement("path", {
    className: "star",
    d: "M50.36 208.61a9.65 9.65 0 0 1-5.2-1.6 8.71 8.71 0 0 1-3.7-8.7l11.9-64.5-50.5-45.8a8.47 8.47 0 0 1-2.4-9.1 8.81 8.81 0 0 1 7.3-5.8l70.2-9.5 31.3-58.9a9.2 9.2 0 0 1 12.4-3.6 9.57 9.57 0 0 1 3.6 3.6l31.3 58.9 70.1 9.5a8.78 8.78 0 0 1 7.3 5.9 8.58 8.58 0 0 1-2.4 9.2l-50.5 45.7 11.9 64.5a8.71 8.71 0 0 1-3.7 8.7 9.39 9.39 0 0 1-5.2 1.6 9.78 9.78 0 0 1-4.1-.9l-62.8-30.7-62.8 30.7a10.57 10.57 0 0 1-4 .8zm132.8-8.5zm-133.2-1.4zm67.2-32.9l65.5 32-12.5-67.7 52.5-47.6-72.6-9.8-32.9-61.8-32.9 61.9-72.6 9.8 52.5 47.5-12.5 67.7zM9.56 80.61zm106.8-71.3zm1.7 0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Star;